import { Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import RefuseSelect from '../RefuseSelect';
import './styles.scss';
const SelfieComponent: React.FC = () => {
  const selfie = useSelector((state: ApplicationState) => state.driver?.selfie);
  return (
    <div style={{ display: 'flex' }}>
      <div className="selfie-container">
        {selfie ? (
          <img src={selfie} alt="selfie" width="350px" />
        ) : (
          <Typography variant="body1">Sem imagem</Typography>
        )}
      </div>
      <RefuseSelect step={2} />
    </div>
  );
};

export default SelfieComponent;
